import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/es/blog/annex-xiv-common-delays")({
  head: () => buildRouteHead("/es/blog/annex-xiv-common-delays", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ href: "/en/blog/annex-xiv-common-delays", replace: true });
  },
});
